import React from 'react';
import { Box, Link, Placeholder, Text } from '@stitch-fix/mode-react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

/**
 * Displays the brand, name, and brand category link (optionally) of a product.
 * Also contains shimmer loading effect.
 */
const ProductTitle = () => {
  const [state] = useProductDetailsPageContext();

  const { reportSelectEvent } = useSelectEvent();

  const onClick = () => {
    reportSelectEvent({
      action_name: 'navigate_to_category',
      category_id: 'brand_category_link',
      name: 'brand_category_link',
      schema: 'category_select',
    });
  };

  const showPlaceholders = state.loading || !state.shopProduct;

  const placeholder = () => {
    return (
      <>
        <Text color="gray-16" setting="eyebrow-medium">
          <Placeholder maxWidth={8} />
        </Text>
        <Text color="gray-16" setting="title-medium">
          <Placeholder maxWidth={20} />
        </Text>
      </>
    );
  };

  const brand = state.shopProduct?.brand?.name || '';
  const brandCategoryLink =
    state.shopProduct?.shopBrandCategoryLink?.destinationPath || '';

  return showPlaceholders ? (
    placeholder()
  ) : (
    <Box mb={{ sm: 0.5, md: 1 }}>
      <Text
        color="gray-16"
        setting="eyebrow-medium"
        data-testid="product-brand"
      >
        {!state.isStaticView && brandCategoryLink ? (
          <Link href={brandCategoryLink} size="tertiary" onClick={onClick}>
            {brand}
          </Link>
        ) : (
          <Box mb={{ sm: 0.25, md: 0.5 }}>{brand}</Box>
        )}
      </Text>
      <Text color="gray-16" setting="title-medium">
        {state.shopProduct?.name || ''}
      </Text>
    </Box>
  );
};

export default ProductTitle;
